import LoadingLogo from '@/components/atoms/LoadingLogo';
import { Flex } from '@chakra-ui/react';

type Props = {
  position?: 'absolute' | 'fixed';
};

const LoadingPage = ({ position = 'absolute' }: Props) => {
  return (
    <Flex
      width="100vw"
      height="100vh"
      flexDirection="column"
      alignItems={'center'}
      justifyContent={'center'}
      top={0}
      left={0}
      position={position}
    >
      <LoadingLogo />
    </Flex>
  );
};

export default LoadingPage;
